export default "__VITE_ASSET__DVZlyzgK__"